var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xprofit-tour"},[_c('v-tour',{attrs:{"name":"xprofittour","steps":_vm.steps,"options":_vm.myOptions,"callbacks":_vm.myCallbacks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }